<template>
    <div class="table-container">
        <el-table
            :data="orders"
            v-loading="isLoading"
            size="small"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    {{props.row.memo||'-暂无备注-'}}
                </template>
            </el-table-column>
            <el-table-column
                prop="number"
                label="订单号"
                width="160"
            ></el-table-column>
            <el-table-column
                prop="type"
                label="类型"
                width="160"
            >
                <template slot-scope="props">
                    <el-tag
                        size="mini"
                        type="primary"
                        v-if="props.row.type==='demand'"
                    >需求</el-tag>
                    <el-tag
                        size="mini"
                        type="warning"
                        v-else-if="props.row.type==='technique'"
                    >技术</el-tag>
                    <el-tag
                        size="mini"
                        type="danger"
                        v-else-if="props.row.type==='specialist'"
                    >专家</el-tag>
                    <el-tag
                        size="mini"
                        v-else
                    >未知</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="subject"
                label="标题"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="price"
                label="价格"
                width="100"
                :formatter="currencyFormatter"
            >
            </el-table-column>
            <el-table-column
                prop="amount"
                label="实际支付"
                width="120"
                :formatter="currencyFormatter"
            ></el-table-column>
            <el-table-column
                prop="client_name"
                label="联系人"
            ></el-table-column>
            <el-table-column
                prop="client_phone"
                label="联系电话"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="client_company"
                label="联系人公司"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="state"
                label="状态"
                :formatter="stateFormatter"
                width="120"
            ></el-table-column>
            <el-table-column
                prop="created_at"
                label="创建时间"
                width="140"
                :formatter="unixFormatter"
            ></el-table-column>
            <el-table-column
                prop="rate"
                label="评分"
                width="140"
            >
                <template slot-scope="props">
                    <el-rate
                        :value="props.row.rate"
                        disabled
                    ></el-rate>
                </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="140"
            >
                <template slot-scope="scope">
                    <template v-if="scope.row.state===1">
                        <ox-safe-button
                            @confirm="onStateChange(scope.row, 2)"
                            type="text"
                            size="small"
                        >完成</ox-safe-button>
                        <el-divider direction="vertical"></el-divider>
                        <ox-safe-button
                            v-if="scope.row.state===1"
                            @confirm="onStateChange(scope.row, 4)"
                            type="text"
                            size="small"
                        >中止</ox-safe-button>
                    </template>
                    <template v-else-if="scope.row.state===0">
                        <el-divider direction="vertical"></el-divider>
                        <ox-safe-button
                            @confirm="remove(scope.row)"
                            type="text"
                            size="small"
                        >删除</ox-safe-button>
                    </template>
                    <el-button v-else size="mini" type="text" :disabled="true">已完成</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="onPageChange"
                :page-size="pagination.size"
                :current-page="pagination.current"
                :total="pagination.total"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
import { pageMixin, fmtMixin } from "@/ox/Mixins";
import OxSafeButton from "@/ox/components/OxSafeButton";

const states = {
    所有: null,
    未支付: 0,
    已支付: 1,
    已完成: 2,
    已评价: 3,
    已中止: 4
};

export default {
    name: "OrderTable",
    mixins: [pageMixin, fmtMixin],
    components: {
        OxSafeButton
    },
    data: function() {
        return {
            page: 1,
            isLoading: false,
            orders: []
        };
    },

    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.isLoading = true;
            const currentPage = page || this.page;
            const query = new window.BaaS.Query();
            const { filter } = this.$parent;
            const state = states[filter.state];
            if (state !== null) {
                query.compare("state", "=", state);
            }
            if (filter.keyword) {
                query.contains(filter.column, filter.keyword.trim());
            }
            this.$ox
                .service("order")
                .find(query, {
                    page: currentPage,
                    withCount: true,
                    orderBy: ["-created_at"]
                })
                .then(res => {
                    this.isLoading = false;
                    this.pagination.size = res.meta.limit;
                    this.pagination.total = res.meta.total_count;
                    this.pagination.current = currentPage;
                    this.page = currentPage;
                    this.orders = res.objects;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        stateFormatter(row, column, cellValue) {
            switch (cellValue) {
                case 0:
                    return (
                        <el-tag type="warning" size="mini">
                            未支付
                        </el-tag>
                    );
                case 1:
                    return <el-tag size="mini">已支付</el-tag>;
                case 2:
                    return (
                        <el-tag type="success" effect="plain" size="mini">
                            已完成
                        </el-tag>
                    );
                case 3:
                    return (
                        <el-tag type="success" size="mini">
                            已评价
                        </el-tag>
                    );
                case 4:
                    return (
                        <el-tag type="danger" size="mini">
                            已中止
                        </el-tag>
                    );
                default:
                    return (
                        <el-tag type="info" size="mini">
                            未知状态
                        </el-tag>
                    );
            }
        },
        onPageChange(page) {
            this.loadData(page);
        },
        onStateChange(row, state) {
            this.$ox
                .service("order")
                .update(row.id, { state })
                .then(() => {
                    this.orders = this.orders.map(app => {
                        if (app.id === row.id) {
                            app.state = state;
                        }
                        return app;
                    });
                    this.$ox.eventBus.$emit('order-handled');
                    this.$notify.success({
                        title: "操作成功",
                        message: `订单“${row.subject}”状态已修改`
                    });
                });
        },
        remove(row) {
            this.$ox
                .service("order")
                .delete(row.id)
                .then(() => {
                    this.orders = this.orders.filter(
                        order => order.id !== row.id
                    );
                    this.$notify.success({
                        title: "操作成功",
                        message: `订单“${row.subject}”已删除`
                    });
                });
        }
    }
};
</script>

<style scoped>
</style>
